import { DropZone } from '@design-system/components/dropZone/dropZone';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import { EditWorkoutVM } from '../view-models/workoutEdit.viewModel';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@mui/material';

type Format = 'image' | 'video' | 'audio';

type MediaEditorProps = {
  influencerId: number;
  accept: string;
  format: Format;
  src: string | null;
  dispatch: EditWorkoutVM['dispatch'];
  loading: boolean;
  disabled: boolean;
};

export const MediaEditor = ({
  accept,
  format,
  src,
  loading,
  dispatch,
  disabled,
}: MediaEditorProps) => {
  return (
    <div
      className={clsx(
        sprinkles({ bg: src ? 'inherit' : 'N-10' }),
        'flex justify-center items-center px-2 py-4 w-[161px] h-[221px] rounded-lg',
      )}
    >
      {loading ? (
        <CircularProgress />
      ) : src ? (
        <Preview format={format} src={src} dispatch={dispatch} />
      ) : disabled ? null : (
        <DropZone
          onChange={(files: File[]) => dispatch('uploadMedia', files[0])}
          accept={[accept]}
          className="text-center border-none"
          textClassName="text-[14px] font-medium leading-5"
          hideIcon={true}
          bgColor={sprinkles({ bg: 'N-10' })}
        />
      )}
    </div>
  );
};

const Preview = ({
  format,
  src,
  dispatch,
}: {
  format: Format;
  src: string;
  dispatch: EditWorkoutVM['dispatch'];
}) => {
  switch (format) {
    case 'image':
      return (
        <div className="relative">
          <img
            src={src}
            className={clsx(
              sprinkles({ clipPath: 'm' }),
              'w-[161px] h-[221px] object-cover',
            )}
            data-testid="workoutThumbnail"
          />
          <FontAwesomeIcon
            icon={faCircleXmark}
            className="absolute top-[8px] right-[8px] text-[20px] text-white text-opacity-60 cursor-pointer"
            onClick={() => dispatch('removeThumbnail')}
          />
        </div>
      );
    case 'video':
      return (
        <div className="relative">
          <video
            src={src}
            className={clsx(
              sprinkles({ clipPath: 'sm' }),
              'w-[161px] h-[221px] object-cover',
            )}
            controls
            data-testid="workoutIntro"
          />
          <FontAwesomeIcon
            icon={faCircleXmark}
            className="absolute top-[8px] right-[8px] text-[20px] text-white text-opacity-60 cursor-pointer"
            onClick={() => dispatch('removeIntro')}
          />
        </div>
      );
  }
};
